import axios from "axios";
import { FormEvent, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import DetailCommande from "../../Views/Admin/historique/DetailCommande";

export default function ConfirmeCommande(){
    const [MessageSucess,setMessageSucess] = useState<string>("");
    const [MessageError,setMessageError] = useState<string>("");
    const navigate = useNavigate();


  //     const location = useLocation();
  // const { ref, nommagasin, qte } = location.state;

  // console.log(ref, nommagasin, qte);
  const ValideCommande = async (id:any)=>{
      try {
    const response = await axios.post(
      `${process.env.REACT_APP_PHP_APP_URL}/valide/commande/${id}`,
      {id}
    );
    if (response.data.status === 400) {
      setMessageError(response.data.message);
          setTimeout(() => {
      setMessageError('');
    }, 2500);
      return false;
    } else {
      setMessageSucess(response.data.message);
          setTimeout(() => {
      setMessageSucess('');
    }, 2500);
      return true;
    }

    setTimeout(() => {
      setMessageError('');
      setMessageSucess('');
    }, 2500);
  } catch (error) {
    setMessageError("Une erreur est survenue.");
    return false;
  }
  }

const handleSubmitUpdate = async (
  ref: string,
  nommagasin: string,
  qte: number,
  id:number,
) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_PHP_APP_URL}/confirme/magasin/${id}/${nommagasin}`,
      { qte ,id}
    );
console.log("Called with:", ref, nommagasin, qte);
    if (response.data.status === 400) {
      setMessageError(response.data.message);
          setTimeout(() => {
      setMessageError('');
    }, 2500);
      return false;
    } else {
      setMessageSucess(response.data.message);
          setTimeout(() => {
      setMessageSucess('');
    }, 2500);
      return true;
    }

    setTimeout(() => {
      setMessageError('');
      setMessageSucess('');
    }, 2500);
  } catch (error) {
    setMessageError("Une erreur est survenue.");
    return false;
  }
};

const handleAnnuleCommande = async (id: number) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_PHP_APP_URL}/annule/${id}`
    );
    setMessageError(response.data.message);
    setTimeout(() => {
      setMessageError('');
    }, 3000);
    return true;
  } catch (error) {
    console.log("❌ Une erreur est survenue:", error);
    setMessageError("Une erreur est survenue.");
    return false;
  }
};

        return <>
        <DetailCommande
        MessageSucess={MessageSucess}
        MessageError={MessageError}
        ValideCommande={ValideCommande}
        handleSubmitUpdate={handleSubmitUpdate}
        handleAnnuleCommande={handleAnnuleCommande}
        />
    </>
}    
